import { Splide } from "@splidejs/splide";
import { gsap } from 'gsap';

const carousel = () => {
  const targetElms = document.getElementsByClassName('js-fv');
  if(targetElms.length === 0) return;
  
  for(const targetElm of targetElms) {
    const speed = 1500;
    let options = {
      type: "fade",
      speed: speed,
      interval: 5500,
      rewind: true,
      pauseOnFocus: false,
      pauseOnHover: false,
      rewindSpeed: speed,
      autoWidth: true,
      arrows: false,
      pagination: false,
      autoplay: true,
      drag: false, // 576px以下でスワイプ禁止
      reduceMotion: {
        speed: speed,
        rewindSpeed: speed,
      },
      // breakpoints: {
      //   576: {
      //     drag: false, // 576px以下でスワイプ禁止
      //   }
      // }
    }

    const slider = new Splide(targetElm, options);
    // スライド移動時の処理
    slider.on('move', (newIndex) => {
      const slides = targetElm.querySelectorAll('.splide__slide');
      const lastIndex = slides.length - 1;
      
      // すべてのスライドから.is-prevを削除
      slides.forEach(slide => slide.classList.remove('is-last-slide'));
      
      // アクティブなスライドが最後のスライドの場合、その要素に.is-prevを追加
      if(newIndex === 0) {
        slides[lastIndex].classList.add('is-last-slide');
      }
    });
    slider.mount();
}

}
const carouselOut = () => {
  const targetElms = document.getElementsByClassName('js-fv-out');
  if(targetElms.length === 0) return;
  
  for(const targetElm of targetElms) {
    const speed = 1500;
    let options = {
      type: "fade",
      speed: speed,
      interval: 5500,
      rewind: true,
      pauseOnFocus: false,
      pauseOnHover: false,
      rewindSpeed: speed,
      autoWidth: true,
      arrows: false,
      pagination: false,
      autoplay: true,
      drag: false,
      reduceMotion: {
        speed: speed,
        rewindSpeed: speed,
      },
    }

    const slider = new Splide(targetElm, options);
    
    // GSAPタイムラインを作成
    const tl = gsap.timeline();
    
    // 5.5秒後にis-prevクラスを追加
    tl.to('.js-fv-out-content', {
      duration: 0,
      onComplete: () => {
        const contentElm = document.querySelector('.js-fv-out-content');
        if(contentElm) {
          contentElm.classList.add('is-prev');
        }
      }
    }, 5.5); // 5.5秒の位置に配置
    
    // タイムライン完了後にスライダーをマウント
    tl.eventCallback('onComplete', () => {
      slider.mount();
    });
    
    // スライド移動時の処理
    slider.on('move', (newIndex) => {
      const slides = targetElm.querySelectorAll('.splide__slide');
      const lastIndex = slides.length - 1;
      
      slides.forEach(slide => slide.classList.remove('is-last-slide'));
      
      if(newIndex === 0) {
        slides[lastIndex].classList.add('is-last-slide');
      }
    });
  }
}

const init = () => {
  carousel();
  carouselOut();
}

export default init;